import { render, staticRenderFns } from "./SnakeGame.vue?vue&type=template&id=b33d7bc2&scoped=true&"
import script from "./SnakeGame.vue?vue&type=script&lang=js&"
export * from "./SnakeGame.vue?vue&type=script&lang=js&"
import style0 from "./SnakeGame.vue?vue&type=style&index=0&id=b33d7bc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33d7bc2",
  null
  
)

export default component.exports